import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Head from 'Components/helpers/Head';
import Hero from 'Components/public/contact/Hero';
import Usp from 'Components/public/contact/Usp';
import Team from 'Components/public/contact/Team';


@connect(
    (state) => ({
        youtube: state.youtube
    }), {}
)
export default class Contact extends React.Component {
    static propTypes = {
        youtube: PropTypes.shape({
            isInitialized: PropTypes.bool.isRequired
        }).isRequired
    };
    static defaultProps = {};

    render() {
        return (
            <div className="container-contact">
                <Head
                    title={`Tailor-made video & imagery crowdsourced from 3M creatives.`}
                    description={`We help brands scale their visual content efforts with a diverse community of 3 million photographers & videographers from all over the world to increase the ROI of marketing campaigns.`}
                    robots={`index, follow`}
                    canonical={``}
                />
                <Hero />
                <Usp />
                <Team />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/global/Contact/index.js